import { logActivity } from './logActivity';
import Service from './service';

const UPLOADPATH = '/user/resume/upload/';
const PARSEPATH = '/user/resume/parser/';
/**
 *
 * @param {Object} payload
 * @param {File} payload.file files to be uploaded
 * @param {String} payload.userID user id if exist
 * @param {Boolean} [payload.standAlonePage] - TBD, optional
 * @param {any} [payload.source] - TBD, optional
 */
const upload = (payload) => {
  // replace payload with formData
  const formData = new FormData();
  Object.keys(payload).forEach((key) => {
    formData.append(key, payload[key]);
  });
  const serviceUrl = payload.source === 'CareerMap' ? PARSEPATH : UPLOADPATH;
  return Service.post(serviceUrl, formData);
};

const logUploadResumeActivity = (resumeLink) => {
  const data = {
    activityType: 'RESUME_UPLOAD',
    resumeLink,
  };
  logActivity(data);
};
export const uploadService = {
  upload,
  logUploadResumeActivity,
};
